import { render } from "./swiper-gallery-carousel.vue?vue&type=template&id=4d05b6cb"
import script from "./swiper-gallery-carousel.vue?vue&type=script&lang=js"
export * from "./swiper-gallery-carousel.vue?vue&type=script&lang=js"

import "./swiper-gallery-carousel.vue?vue&type=style&index=0&id=4d05b6cb&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__